<script lang="ts">
  import { AppState } from '../../etc/stores';
  import Typography from './Typography.svelte';

  type TypeStyle = 'h1' | 'h2' | 'h3';

  export let textAlign: string = 'left';
  export let color: string = $AppState.theme.colors.typography;
  export let type: TypeStyle = 'h1';
  export let component: string = type;
</script>

<Typography
  {component}
  class="twism-type-style-{type} {$$props.class || ''}"
  {color}
  {textAlign}
>
  <slot />
</Typography>

<style lang="scss">
  :global(.twism-type-style-h1) {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
  }
  :global(.twism-type-style-h2) {
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
  }

  :global(.twism-type-style-h3) {
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
  }
</style>
